import { FeeNature } from "../enums/FeeNature";
import { FlowAuthType } from "../enums/FlowAuthType";

export const useDummyFlowProviders = false;

export const flowProviders = [
    {
        id: 1,
        name: "Storehub POS",
        short_name: "storehub",
        authentication: FlowAuthType.HTTP_BASIC,
        fee_types: [
            {
                id: 1,
                name: "Sales",
                description: null,
                nature: FeeNature.INCOME,
                is_sales: true,
            },
            {
                id: 2,
                name: "Discount",
                description: null,
                nature: FeeNature.INCOME,
                is_sales: false,
            },
            {
                id: 3,
                name: "Service Charges",
                description: null,
                nature: FeeNature.INCOME,
                is_sales: false,
            },
            {
                id: 4,
                name: "Rounding",
                description: null,
                nature: FeeNature.INCOME,
                is_sales: false,
            },
            {
                id: 5,
                name: "Sales Refund",
                description: null,
                nature: FeeNature.INCOME,
                is_sales: true,
            },
            {
                id: 6,
                name: "Discount Refund",
                description: null,
                nature: FeeNature.INCOME,
                is_sales: false,
            },
            {
                id: 7,
                name: "Service Charges Refund",
                description: null,
                nature: FeeNature.INCOME,
                is_sales: false,
            },
            {
                id: 8,
                name: "Rounding Refund",
                description: null,
                nature: FeeNature.INCOME,
                is_sales: false,
            },
            // {
            //     id: 9,
            //     name: "Tax",
            //     description: null,
            //     nature: FeeNature.TAX,
            //     is_sales: false,
            // },
            // {
            //     id: 10,
            //     name: "Tax Refund",
            //     description: null,
            //     nature: FeeNature.TAX,
            //     is_sales: false,
            // },
        ],
        created_at: "2023-01-01 12:00:00",
        updated_at: "2023-01-02 14:30:00",
    },
    {
        id: 2,
        name: "Lazada Ecom",
        short_name: "lazada",
        authentication: FlowAuthType.OAUTH2,
        fee_types: [
            {
                id: 1,
                name: "Sales",
                description: null,
                nature: FeeNature.INCOME,
                is_sales: true,
            },
            {
                id: 2,
                name: "Discount",
                description: null,
                nature: FeeNature.INCOME,
                is_sales: false,
            },
            {
                id: 3,
                name: "Service Charges",
                description: null,
                nature: FeeNature.INCOME,
                is_sales: false,
            },
            {
                id: 4,
                name: "Rounding",
                description: null,
                nature: FeeNature.INCOME,
                is_sales: false,
            },
            {
                id: 5,
                name: "Sales Refund",
                description: null,
                nature: FeeNature.INCOME,
                is_sales: true,
            },
            {
                id: 6,
                name: "Discount Refund",
                description: null,
                nature: FeeNature.INCOME,
                is_sales: false,
            },
            {
                id: 7,
                name: "Service Charges Refund",
                description: null,
                nature: FeeNature.INCOME,
                is_sales: false,
            },
            {
                id: 8,
                name: "Rounding Refund",
                description: null,
                nature: FeeNature.INCOME,
                is_sales: false,
            },
            // {
            //     id: 9,
            //     name: "Tax",
            //     description: null,
            //     nature: FeeNature.TAX,
            //     is_sales: false,
            // },
            // {
            //     id: 10,
            //     name: "Tax Refund",
            //     description: null,
            //     nature: FeeNature.TAX,
            //     is_sales: false,
            // },
            {
                id: 11,
                name: "Custom Fee 1",
                description: "Custom fee for Lazada",
                nature: FeeNature.EXPENSE,
                is_sales: false,
            },
            {
                id: 12,
                name: "Custom Fee 2",
                description: "Another custom fee for Lazada",
                nature: FeeNature.EXPENSE,
                is_sales: false,
            },
        ],
        created_at: "2023-02-01 10:30:00",
        updated_at: "2023-02-02 16:45:00",
    },
];
